import moment from 'moment';

export const calculateDuration = (startTime: string, endTime: string) => {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const newEndTime = new Date(
    start.getFullYear(),
    start.getMonth(),
    start.getDate(),
    end.getHours(),
    end.getMinutes(),
    end.getSeconds(),
  );
  const durationInMins = moment(newEndTime).diff(startTime, 'minutes');
  return durationInMins;
};
